/* eslint-disable */
import _ from 'underscore';
import BaseProjection from '@bingads-webui-component-legacy/grid/projection/base';
import schema_properties from '@bingads-webui-component-legacy/grid/schema/properties';
var Model = BaseProjection.extend({
  defaults: {
    'seed': null
  },
  name: 'sink',
  update: function (options) {
    var value;
    value = this.get('seed');
    if (_.isArray(value)) {
      var select = schema_properties.from(value);
      this.patch({
        value: value,
        select: select,
        count: _.size(value)
      });
    }
  }
});
export default Model;

